import { forwardRef } from 'react';

export const GlassSelect = forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(function GlassSelect({ className, ...props }, ref) {
  return (
    <select
      ref={ref}
      className={`px-4 py-2 border border-white/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 font-bold cursor-pointer ${className ?? ''}`}
      {...props}
    />
  );
});
